var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"flex items-center justify-start gap-2",attrs:{"to":"/"}},[_c('img',{class:this.img_class,attrs:{"src":require("../../assets/logo.svg"),"alt":"Teleportravel Logo"}}),_c('div',{staticClass:"font-semibold",class:this.h_class},[_vm._v(" Teleportravel ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }